// src/shadowGrove/config/branding.js

export const BRANDING = {
    appName: "Liberi Curiosi",
    internalName: "Shadow Grove",
    motto: "Curiosity awakens the Genius within.",
    subtitle: "A magical homeschool operating system",
    academyName: "Liberi Curiosi Academy",
    classroomName: "Schola Minervae",
    rewardShopName: "Taberna Vastae",
    companionName: "Genius",
    defaultGeniusName: "Blueberry",
};